import { combineReducers } from "redux";
import { taxCreditConstants } from "../../actions/taxCredit";

const defStatus = {
  data: {},
  isGettingData: false,
  isErrorGettingData: false,
  status: {
    started: false,
    ended: false,
    error: false
  }
};

function status(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.status : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_DATA_START:
    return {
      started: true,
      ended: false,
      error: false
    };
  case taxCreditConstants.GET_TAX_CREDIT_DATA_SUCCESS:
    return {
      started: false,
      ended: true,
      error: false
    };
  case taxCreditConstants.GET_TAX_CREDIT_DATA_ERROR:
    return {
      started: false,
      ended: false,
      error: true
    };
  case taxCreditConstants.CLEAR_TAX_CREDIT_DATA:
    return {
      started: false,
      ended: false,
      error: false
    };
  default:
    return defaultS;
  }
}

function data(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.data : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_DATA_START:
    return {};
  case taxCreditConstants.GET_TAX_CREDIT_DATA_SUCCESS:
    return payload.data;
  case taxCreditConstants.GET_TAX_CREDIT_DATA_ERROR:
    return {};
  case taxCreditConstants.CLEAR_TAX_CREDIT_DATA:
    return {};
  default:
    return defaultS;
  }
}

function isGettingData(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.isGettingData : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_DATA_START:
    return true;
  case taxCreditConstants.GET_TAX_CREDIT_DATA_SUCCESS:
  case taxCreditConstants.GET_TAX_CREDIT_DATA_ERROR:
  case taxCreditConstants.CLEAR_TAX_CREDIT_DATA:
    return false;
  default:
    return defaultS;
  }
}

function isErrorGettingData(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.isErrorGettingData : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_DATA_ERROR:
    return true;
  case taxCreditConstants.GET_TAX_CREDIT_DATA_START:
  case taxCreditConstants.GET_TAX_CREDIT_DATA_SUCCESS:
  case taxCreditConstants.CLEAR_TAX_CREDIT_DATA:
    return false;
  default:
    return defaultS;
  }
}

function detail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.data : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_DETAIL_START:
    return {};
  case taxCreditConstants.GET_TAX_CREDIT_DETAIL_SUCCESS:
    return payload.data;
  case taxCreditConstants.GET_TAX_CREDIT_DETAIL_ERROR:
    return {};
  case taxCreditConstants.CLEAR_TAX_CREDIT_DETAIL:
    return {};
  default:
    return defaultS;
  }
}

function isGettingDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.isGettingData : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_DETAIL_START:
    return true;
  case taxCreditConstants.GET_TAX_CREDIT_DETAIL_SUCCESS:
  case taxCreditConstants.GET_TAX_CREDIT_DETAIL_ERROR:
  case taxCreditConstants.CLEAR_TAX_CREDIT_DETAIL:
    return false;
  default:
    return defaultS;
  }
}

function isErrorGettingDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.isErrorGettingData : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_DETAIL_ERROR:
    return true;
  case taxCreditConstants.GET_TAX_CREDIT_DETAIL_START:
  case taxCreditConstants.GET_TAX_CREDIT_DETAIL_SUCCESS:
  case taxCreditConstants.CLEAR_TAX_CREDIT_DETAIL:
    return false;
  default:
    return defaultS;
  }
}

function elegibleDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.data : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_START:
    return {};
  case taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_SUCCESS:
    return payload.data;
  case taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_ERROR:
    return {};
  case taxCreditConstants.CLEAR_TAX_CREDIT_ELEGIBLE_DETAIL:
    return {};
  default:
    return defaultS;
  }
}

function isGettingElegibleDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.isGettingData : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_START:
    return true;
  case taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_SUCCESS:
  case taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_ERROR:
  case taxCreditConstants.CLEAR_TAX_CREDIT_ELEGIBLE_DETAIL:
    return false;
  default:
    return defaultS;
  }
}

function isErrorGettingElegibleDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.isErrorGettingData : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_ERROR:
    return true;
  case taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_START:
  case taxCreditConstants.GET_TAX_CREDIT_ELEGIBLE_DETAIL_SUCCESS:
  case taxCreditConstants.CLEAR_TAX_CREDIT_ELEGIBLE_DETAIL:
    return false;
  default:
    return defaultS;
  }
}

function inProgressDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.data : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_START:
    return {};
  case taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_SUCCESS:
    return payload.data;
  case taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_ERROR:
    return {};
  case taxCreditConstants.CLEAR_TAX_CREDIT_INPROGRESS_DETAIL:
    return {};
  default:
    return defaultS;
  }
}

function isGettingInProgressDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.isGettingData : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_START:
    return true;
  case taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_SUCCESS:
  case taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_ERROR:
  case taxCreditConstants.CLEAR_TAX_CREDIT_INPROGRESS_DETAIL:
    return false;
  default:
    return defaultS;
  }
}

function isErrorGettingInProgressDetail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defStatus.isErrorGettingData : state;
  switch (type) {
  case taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_ERROR:
    return true;
  case taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_START:
  case taxCreditConstants.GET_TAX_CREDIT_INPROGRESS_DETAIL_SUCCESS:
  case taxCreditConstants.CLEAR_TAX_CREDIT_INPROGRESS_DETAIL:
    return false;
  default:
    return defaultS;
  }
}

export const taxCredit = combineReducers({
  status,
  data,
  detail,
  elegibleDetail,
  inProgressDetail,
  isGettingData,
  isErrorGettingData,
  isGettingDetail,
  isErrorGettingDetail,
  isGettingElegibleDetail,
  isErrorGettingElegibleDetail,
  isGettingInProgressDetail,
  isErrorGettingInProgressDetail
});

export default taxCredit;
